<template>
  <div class="brackets-final">
    <div class="container">
      <Toolbar class="brackets-final__toolbar" title-tag="h1">
        <template #title>
          Национальный финал
        </template>
      </Toolbar>
      <div class="brackets-final__bracket-wrapper">
        <BracketFinalStage />
      </div>
    </div>
  </div>
</template>

<script>
import BracketFinalStage from "@/components/brackets/BracketFinalStage";
import { Toolbar } from "@/components/ui/toolbar/";

export default {
  name: "BracketsViewPage",

  components: {
    Toolbar,
    BracketFinalStage
  },

  breadcrumb: {
    title: "Финал",
    to: "/brackets/final"
  }
};
</script>

<style lang="scss">
.brackets-final {
  &__toolbar {
    position: relative;
    z-index: 1;
  }

  &__bracket-wrapper {
    width: 100%;
    background-color: #fff;
    overflow-y: auto;
  }
}
</style>
